import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/dashboard.css */
  #my-dashboard-grid {
    width: 100%;
    margin: 20px 0 0 0;
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .main_cards.full:first-child {
    margin-top: 0;
  }
  .card {
    padding: 30px;
    background: rgba(129, 170, 255, 0.06);
    background: var(--side-panel-background);
    border-radius: 15px;
    display: flex;
    position: relative;
    align-items: flex-start;
    overflow: hidden;
  }
  .main_cards.full.user_dashboard .card {
    padding: 0;
  }
  .card:first-child {
    grid-area: card1;
  }
  .main_cards.full .card {
    display: flex;
    flex-direction: column;
  }
  .main_cards.full.user_dashboard {
    display: flex;
    flex-direction: column;
    margin: 60px 0 0 0;
    width: 100%;
  }
  #my-dashboard-grid .main_cards.full .grid_unclaimed_earnings {
    width: 100%;
    display: grid;
    grid-template-columns: ${({ gridColumns }) => gridColumns};
    font-size: 0.8rem;
    /* max-height: 300px; */
    /* overflow-y: auto; */
  }
  .main_cards.full .grid_unclaimed_earnings > span {
    padding: 12px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.2);
    font-size: 0.9rem;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .main_cards.full .grid_unclaimed_earnings > span.head {
    font-size: 0.8rem;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .main_cards.full .grid_unclaimed_earnings > span.head:first-child {
    border-top-left-radius: 10px;
  }
  .main_cards.full .grid_unclaimed_earnings > span.head:last-child {
    border-top-right-radius: 10px;
  }
  .main_cards.full .grid_unclaimed_earnings > span.head strong {
    font-weight: 600;
    margin: 0 3px 0 0;
  }
  .triangle.up.white {
    width: 10px;
    height: 10px;
    mask: url(${icons.arrow_up}) no-repeat;
    mask-size: 10px 10px;
    background: var(--primary-text-color);
  }
  .triangle.button.white {
    background: var(--input-background);
    border-radius: 5px;
    padding: 6px;
  }
  .tabs_wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
  .tabs_wrapper .panels {
    width: 100%;
    overflow: hidden;
  }
  .tabs_wrapper .panel {
    width: 100%;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    border-top-right-radius: 15px;
    padding: 0 15px 15px 15px;
  }
  .card * {
    display: flex;
  }
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/wallet.css */
  .panel_title {
    font-size: 1.2rem;
    font-weight: 600;
    text-transform: uppercase;
    width: 100%;
    display: flex;
    align-items: center;
    flex-flow: column;
    text-align: center;
  }
  .tabbed_section {
    background: var(--tab-section-background);
    border-radius: 10px;
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 0 10px 0 0;
  }
  .tabbed_section.deposit_history {
    width: 100%;
    margin: 10px 0 0 0;
  }
  .tabbed_section {
    display: flex;
    flex-flow: column;
    align-items: flex-start;
  }
  .tabbed_section form {
    display: flex;
    flex-flow: column;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: flex-start;
  }
  #my-dashboard-grid {
    margin: 20px 0 0 0;
  }
  .main_cards.full.user_dashboard {
    margin: 0;
  }
  @media (max-width: 1200px) {
    .tabbed_section {
      margin: 0 0 10px 0;
    }
  }
`

const developerCSS = css`
  .cell {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
`

export const WalletTransactionsCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
